import styled from 'styled-components';
import { Box } from '@resideo/blueprint-react';

export const UserTerms = styled(Box)`
  line-height: 28px;
`;
